export default [
  {
    path: '',
    name: 'shop order list',
    component: () => import('@/views/app/shop-order/list/page-list.vue'),
    meta: { title: 'Daftar Pesanan' },
  },
  {
    path: ':id',
    name: 'shop order detail',
    component: () => import('@/views/app/shop-order/detail/page-detail.vue'),
    meta: { title: 'Detail Informasi Pesanan' },
  },
]
